import SectionHub from '@/components/docs/SectionHub';

export default function Docs04MacrosAndSignalsEconomicDatasetsHub() {
  return <SectionHub sectionPath="04-macros-and-signals/economic-datasets" />;
}
